// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"SelfiesTip_style_b-icon-warning__xswm+","wrapper":"SelfiesTip_style_wrapper__Ziy15","rotate":"SelfiesTip_style_rotate__9ugkL"};